import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorQueryKey } from '@/modules/operator/keys'
import {
	GetUploadFileUrlResponse,
	GetUploadlFileUrlRequest,
} from '@/modules/operator/type'
import { getPromotionUploadFileUrl } from '../../services'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreatePromotionBannerFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [OperatorQueryKey.GetUploadPromotionFileUrl],
		mutationFn: (params) => getPromotionUploadFileUrl(params.payload),
		...props,
	})
}
